<template>
  <v-btn v-on:click="navigate">
    <v-icon class="pr-2">mdi-file</v-icon>
    {{ title }}
  </v-btn>
</template>

<script>
export default {
  name: "ExcelButton",
  props: {
    type: String,
    title: {
      type: String,
      default: "Örnek Excel",
    },
  },
  methods: {
    navigate() {
      const endpoint = "https://api.vatansms.com/";
      switch (this.type) {
        case "contact":
          window.open(`${endpoint}Rehber_Kayit_Ornek.xlsx`);
          break;
        case "advanced":
          window.open(`${endpoint}Ozel_Tasarim_Ornek.xlsx`);
          break;
        case "number_message":
          window.open(`${endpoint}Numara_Mesaj_Ornek.xlsx`);
          break;
        case "iys_add_eposta":
          window.open(`${endpoint}iys-numara-ekleme.xlsx`);
          break;
        case "iys_add_number":
          window.open(`${endpoint}iys-eposta-ekleme.xlsx`);
          break;
        default:
          break;
      }
    },
  },
};
</script>
